import type { IReceiptPort } from '@onboarding/application/ports';
import type { StoreBrandDto } from '@onboarding/application/dtos';

/**
 * Use case for fetching the store's brands.
 *
 * Flow: port.getStoreBrands() → StoreBrandDto[]
 *
 * @param props.receiptPort - IReceiptPort implementation (injected)
 * @returns Use case executor
 */
export const fetchStoreBrandsUseCase = (props: { receiptPort: IReceiptPort }) => {
  const { receiptPort } = props;

  const execute = async (): Promise<StoreBrandDto[]> => {
    const brands = await receiptPort.getStoreBrands();
    return brands.map((b) => ({ uuid: b.uuid, name: b.name }));
  };

  return { execute };
};
